module.exports = __webpack_public_path__ + "static/media/help-circle.028dae5e.svg";